export default "__VITE_ASSET__ad5bc89d__"